<template>
  <div>
    <form
        ref="form"
        data-url="/accreditationtechnical/desicionmaking/update"
        :class="{ 'loading-opacity': preloader }"
        enctype="multipart/form-data"
    >
    <div class="row mt-2 mb-2">
          <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
              <h4>Regresar estado anterior</h4>
          </legend>

          <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("¿Desea volver al estado anterior?") }}
              </label>
              <app-input
                  type="radio-buttons"
                  class="col-sm-9"
                  v-model="previousbutton"
                  :list="optionsPreviousState"
              />
          </div>

          <div v-if="previousbutton == 1" class="form-group row align-items-center">
              <div class="col-md-12 mt-2">
                <label>Observaciones<b class="text-danger ml-2" style="font-size: 18px !important">*</b></label>
                <app-input
                  type="textarea"
                  v-model="observation_return"
                  placeholder="Ingrese la Observación"
                />
                  <button
                      type="submit"
                      class="btn btn-primary mt-2"
                      @click.prevent="openModalConfirm()"
                  >
                      {{ $t("Continuar") }}
                  </button>
              </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!--
        <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
            <h5>Evaluaciones</h5>
          </legend>
        </div>
        <div class="col-12">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">Expediente</th>
                <th scope="col">Tipo</th>
                <th scope="col">Código</th>
                <th scope="col" class="text-center" style="width: 10%">
                  Documento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, key) in evaluations" :key="key">
                <td class="align-middle">
                  {{ value.accreditation_applications.record }}
                </td>
                <td class="align-middle">
                  <p v-if="value.type == 'E'">Evaluación</p>
                  <p v-if="value.type == 'T'">Testificación</p>
                </td>
                <td class="align-middle">{{ value.code }}</td>
      
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openModal(value)"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        -->
        <div class="col-12">
          <legend class="col-form-label text-primary pt-0 mb-3">
            <h5>Documentos</h5>
          </legend>

          <div class="row mt-3">
            <div class="col-12">
              <h4 class="text-primary">
                Necesita realizar comisión?
              </h4>

              <div class="form-group">
                <app-input
                    id="inputs_name"
                    class="col-sm-9"
                    type="radio-buttons"
                    v-model="commission"
                    :list="list_commi"
                />
              </div>
            </div>
          </div>

          <div class="row mt-3" v-if="commission">
            <div class="col-12">
              <h4 class="text-primary">
                CONVOCATORIA COMISIÓN DE ACREDITACIÓN
              </h4>
              <div class="form-group mt-2">
                <p>Justificación del porque se realiza comisión</p>
                <app-input
                  type="textarea"
                  v-model="commission_subject"
                  :required="true"
                  placeholder="Ingrese la justificación"
                />
              </div>
              <div class="form-group row">
                <label for="inputs_name" class="col-sm-3 mb-0">
                  {{ $t("Seleccionar comisión") }}
                </label>
                <app-input
                    style="border: 1px solid #d6d6d6; border-radius: 10px"
                    class="col-sm-9"
                    type="multi-select"
                    :list="list"
                    :isAnimatedDropdown="true"
                    v-model="members"
                />
              </div>
              <div class="col-sm-12" style="text-align: center">
                <h5 class="text-success">{{ titulo }}</h5>
                <!-- SI input.select == 1 -->
                <table class="table table-sm table-bordered text-center">
                  <thead>
                  <tr>
                    <td scope="col" colspan="2">INTEGRANTE</td>
                    <td scope="col" colspan="2">REQUISITOS</td>
                    <td scope="col" colspan="2" class="text-danger"></td>
                  </tr>
                  <tr>
                    <td scope="col">NOMBRE</td>
                    <td scope="col">INSTITUCIÓN</td>
                    <td scope="col">Evaluador</td>
                    <td scope="col">Conocimiento procedimientos acreditación</td>
                    <td scope="col">Competencia técnica afín al sector</td>
                    <td scope="col">Representante externo</td>
                    <td scope="col">Verificación de competencia</td>
                    <!-- <td scope="col">Seleccionado</td> -->
                    <td scope="col">Presidente</td>
                  </tr>
                  <tr v-for="(value, key) in fields" :key="key">
                    <td scope="col" style="border-right: hidden">
                      {{ value.full_name }}
                    </td>
                    <td scope="col" style="border-right: hidden">
                      {{ value.institution }}
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.evaluator"
                          v-if="value.selected == 1"
                      />
                    </td>

                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.accreditation_procedure"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.experience"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.external_representative"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.rule"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.coordinator"
                          v-if="value.selected == 1"
                      />
                    </td>
                  </tr>
                  </thead>
                  <tbody></tbody>
                </table>

                <!-- SI input.select == 2 -->
                <table
                    class="table table-sm table-bordered text-center"
                    v-if="inputs.select == 2"
                >
                  <thead>
                  <tr>
                    <td scope="col" colspan="2">INTEGRANTE</td>
                    <td scope="col" colspan="2">ÁREA DE CONOCIMIENTO</td>
                    <td scope="col" colspan="2" class="text-danger">
                      <!-- NO HA REALIZADO OPERACIÓN -->
                    </td>
                  </tr>
                  <tr>
                    <td scope="col">NOMBRE</td>
                    <td scope="col">INSTITUCIÓN</td>
                    <td scope="col">Norma y criterio de acreditación</td>
                    <td scope="col">Experticia Técnica</td>
                    <td scope="col">Seleccionado</td>
                    <td scope="col">Presidente</td>
                  </tr>
                  <tr v-for="(value, key) in fields" :key="key">
                    <td scope="col" style="border-right: hidden">
                      {{ value.full_name }}
                    </td>
                    <td scope="col" style="border-right: hidden">
                      {{ value.institution }}
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.rule"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.experience"
                          v-if="value.selected == 1"
                      />
                    </td>
                    <td scope="col" style="border-right: hidden">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.selected"
                      />
                    </td>
                    <td scope="col">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.coordinator"
                          v-if="value.selected == 1"
                      />
                    </td>
                  </tr>
                  </thead>
                  <tbody></tbody>
                </table>

                <!-- SI input.select == 3 -->
                <table
                    class="table table-sm table-bordered text-center"
                    v-if="inputs.select == 3"
                >
                  <thead>
                  <tr>
                    <td scope="col" colspan="2">INTEGRANTE</td>
                    <td scope="col" colspan="2" class="text-danger">
                      <!-- NO HA REALIZADO OPERACIÓN -->
                    </td>
                  </tr>
                  <tr>
                    <td scope="col">NOMBRE</td>
                    <td scope="col">INSTITUCIÓN</td>
                    <td scope="col">Seleccionado</td>
                  </tr>
                  <tr v-for="(value, key) in fields" :key="key">
                    <td scope="col" style="border-right: hidden">
                      {{ value.full_name }}
                    </td>
                    <td scope="col" style="border-right: hidden">
                      {{ value.institution }}
                    </td>

                    <td scope="col">
                      <input
                          type="checkbox"
                          id="inputs_approved"
                          v-model="value.selected"
                      />
                    </td>
                  </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
              <div class="col-12">
                <app-note
                    class="mb-primary"
                    :show-title="false"
                    :notes="['Todos los campos con un (*) son obligatorios.']"
                />
              </div>

              <div class="col-12">
                <h4 class="text-primary">Datos de la reunión</h4>
              </div>
              <div class="col-12">
                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("Tipo de comisión") }}
                  </label>
                  <app-input
                      type="radio-buttons"
                      class="col-sm-9"
                      v-model="personal_remote"
                      :list="options"
                  />
                </div>
              </div>
              <div class="col-12">
                <div
                    class="form-group row align-items-center"
                    v-if="personal_remote == 1"
                >
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("Link de reunión") }} <b class="text-danger">*</b>
                  </label>
                  <app-input class="col-sm-9" type="text" v-model="meeting_link"/>
                </div>
                <div
                    class="form-group row align-items-center"
                    v-if="personal_remote == 0"
                >
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("Registrar una dirección") }} <b class="text-danger">*</b>
                  </label>
                  <app-input class="col-sm-9" type="text" v-model="meeting_link"/>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row align-items-center">
                  <label for="inputs_name" class="col-sm-3 mb-0">
                    {{ $t("Fecha y hora de reunión") }} <b class="text-danger">*</b>
                  </label>
                  <app-input
                      id="inputs_name"
                      class="col-sm-4"
                      type="date"
                      v-model="meeting_date"
                      :required="true"
                      :placeholder="$t('Agregar fecha')"
                  />
                  <app-input
                      class="col-sm-2"
                      type="time"
                      :required="true"
                      v-model="meeting_time"
                      :placeholder="$t('Agregar hora')"
                  />
                </div>
              </div>
              <div class="col-12">
                <p>
                  <b
                  >Se comunica, además, que la información a revisar por los
                    miembros de la Comisión de Acreditación del SAE, encargados de la
                    toma de decisiones de acreditación, incluye lo siguiente:
                  </b>
                </p>
                <p>a) La identificación única del OEC;</p>
                <p>
                  b) Las fechas y tipos de evaluación (por ejemplo evaluación inicial,
                  reevaluación, etc.); ;
                </p>
                <p>
                  c) Los nombres de los evaluadores y de los expertos técnicos
                  involucrados en la evaluación; ;
                </p>
                <p>
                  d) La identificación única de todas las ubicaciones evaluadas y
                  localizaciones críticas cuando corresponda; ;
                </p>
                <p>
                  e) El alcance de la acreditación que se ha evaluado y/o modificado;
                  ;
                </p>
                <p>
                  f) Los informes de evaluación y/o testificación según corresponda;;
                </p>
                <p>
                  g) Una declaración sobre la adecuación de la organización y sobre
                  los procedimientos adoptados por el OEC para dar confianza en su
                  competencia, según lo determinado por el cumplimiento de los
                  requisitos de acreditación; ;
                </p>
                <p>
                  h) La información suficiente para demostrar la respuesta
                  satisfactoria ante todas las no conformidades;;
                </p>
                <p>
                  i) Cuando sea pertinente, cualquier información adicional que pueda
                  ayudar a determinar la competencia del OEC determinado a través de
                  la conformidad con los requisitos.;
                </p>
                <br/>
              </div>


            </div>
            <div class="col-sm-12 align-items-center mb-4" >
              <button
                  :class="{ 'loading-opacity': preloader }"
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="submitNotify"
              >
                Enviar notificación
              </button>
            </div>
          </div>


          <table class="table table-sm table-striped" v-if="docs">
            <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">
                ACCIÓN
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="docs.request_signed">
              <td class="align-middle">Solicitud de acreditación firmada</td>
              <td class="align-middle">
                {{ docs.request_signed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.request_signed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(docs, 'request_signed')"
                >
                  <app-icon name="file"/>
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="docs.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  docs.user
                      ? `${docs.user.first_name} ${docs.user.last_name}`
                      : ""
                }}
              </td>
              <td class="align-middle">
                {{ docs.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                    class="btn btn-success"
                    :href="`/accreditations/applications/${docs.id}?tab=Anexos`"
                    target="_blank"
                >
                  <app-icon name="file"/>
                  {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="docs.receipt_return_report">
              <td class="align-middle">
                Registro de Ingreso de solicitud de acreditación y acuse
                recibo
              </td>
              <td class="align-middle">
                {{ docs.receipt_return_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ docs.receipt_return_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(docs, 'receipt_return_report')"
                >
                  <app-icon name="file"/>
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12">
          <hr/>
          <div class="row">
            <!-- <div class="col-6">
            <div class="form-group">
              <label
                >Informe de la comisión de acreditación:
                <strong class="text-danger">*</strong></label
              >
              <app-input
                type="file"
                :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
                v-model="inputs.file"
                :required="true"
                v-if="!inputs.evidence_member_participation"
              />
              <div class="mt-2">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'evidence_member_participation')"
                  v-if="inputs.evidence_member_participation"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>

                <button
                  type="submit"
                  class="btn btn-danger"
                  @click.prevent="openDeleteModal('evidence_member_participation')"
                  v-if="inputs.evidence_member_participation"
                >
                  <app-icon name="trash-2" />
                  {{ $t("delete") }}
                </button>
              </div>
            </div>
          </div> -->

            <!--   <div class="col-6">
                 <div class="form-group">
                   <label
                     >Evidencia de participación de los miembros de la comisión:
                     <strong class="text-danger">*</strong></label
                   >
                   <app-input
                     type="file"
                     :label="
                       inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')
                     "
                     v-model="inputs.file_1"
                     :required="true"
                     v-if="!inputs.evidence_member_participation"
                   />
                   <div class="mt-2">
                     <button
                       type="submit"
                       class="btn btn-success"
                       @click.prevent="
                         openTab(inputs, 'evidence_member_participation')
                       "
                       v-if="inputs.evidence_member_participation"
                     >
                       <app-icon name="file" />
                       {{ $t("view") }}
                     </button>

                     <button
                       type="submit"
                       class="btn btn-danger"
                       @click.prevent="confirmed('evidence_member_participation')"
                       v-if="inputs.evidence_member_participation"
                     >
                       <app-icon name="trash-2" />
                       {{ $t("delete") }}
                     </button>
                   </div>
                 </div>
               </div> -->

            <div class="col-6">
              <div class="form-group">
                <label
                >Informe Técnico de Análisis de Expediente:
                  <strong class="text-danger">*</strong></label
                >
                <app-input
                    type="file"
                    :label="
                    inputs.file_2 ? inputs.file_2.name : $t('upload_your_file')
                  "
                    v-model="inputs.file_2"
                    v-if="!inputs.technical_file_analysis_report"
                />
                <div class="mt-2">
                  <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="
                      openTab(inputs, 'technical_file_analysis_report')
                    "
                      v-if="inputs.technical_file_analysis_report"
                  >
                    <app-icon name="file"/>
                    {{ $t("view") }}
                  </button>

                  <button
                      type="submit"
                      class="btn btn-danger"
                      @click.prevent="confirmed('technical_file_analysis_report')"
                      v-if="inputs.technical_file_analysis_report"
                  >
                    <app-icon name="trash-2"/>
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>

            <!--   <div class="col-6">
                 <div class="form-group">
                   <label
                     >Plan de mantenimiento:
                     <strong class="text-danger">*</strong></label
                   >
                   <app-input
                     type="file"
                     :label="
                       inputs.file_3 ? inputs.file_3.name : $t('upload_your_file')
                     "
                     v-model="inputs.file_3"
                     :required="true"
                     v-if="!inputs.maintenance_plan"
                   />
                   <div class="mt-2">
                     <button
                       type="submit"
                       class="btn btn-success"
                       @click.prevent="openTab(inputs, 'maintenance_plan')"
                       v-if="inputs.maintenance_plan"
                     >
                       <app-icon name="file" />
                       {{ $t("view") }}
                     </button>

                     <button
                       type="submit"
                       class="btn btn-danger"
                       @click.prevent="confirmed('maintenance_plan')"
                       v-if="inputs.maintenance_plan"
                     >
                       <app-icon name="trash-2" />
                       {{ $t("delete") }}
                     </button>
                   </div>
                 </div>
               </div>

               <div class="col-6">
                 <div class="form-group">
                   <label
                     >Borrador del Informe Técnico del Director de Área:
                     <strong class="text-danger">*</strong></label
                   >
                   <app-input
                     type="file"
                     :label="
                       inputs.file_4 ? inputs.file_4.name : $t('upload_your_file')
                     "
                     v-model="inputs.file_4"
                     :required="true"
                     v-if="!inputs.director_technical_report"
                   />
                   <div class="mt-2">
                     <button
                       type="submit"
                       class="btn btn-success"
                       @click.prevent="
                         openTab(inputs, 'director_technical_report')
                       "
                       v-if="inputs.director_technical_report"
                     >
                       <app-icon name="file" />
                       {{ $t("view") }}
                     </button>

                     <button
                       type="submit"
                       class="btn btn-danger"
                       @click.prevent="
                         openDeleteModal('director_technical_report')
                       "
                       v-if="inputs.director_technical_report"
                     >
                       <app-icon name="trash-2" />
                       {{ $t("delete") }}
                     </button>
                   </div>
                 </div>
               </div> -->
            <br/>
            <div class="col-12 mt-3">
              <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="submit"
              >
                {{ $t("save") }}
              </button>
              <br/>
              <hr/>
            </div>

            <div class="col-12">
              <legend>
                <small class="text-primary"
                >Documentos adicionales para subsanar o complementar el
                  proceso</small
                >
              </legend>
            </div>
          </div>
        </div>
      </div>
      <app-confirmation-modal
          v-if="deleteModal"
          modal-id="delete"
          @confirmed="confirm"
          @cancelled="cancelled"
      />

      <director-area-modal
          v-if="isAddEditModalActive"
          :selected-url="selectedUrl"
          @close-modal="closeAddEditModal"
      />
    </form>
    <div class="row">
      <div class="col-12">
        <div class="row mb-2" v-for="(vj, j) in additional_600" :key="j">
          <div class="col-12 col-md-5" v-if="!vj.annexed">
            <app-input
                :id="`file_${j}`"
                type="file"
                :label="vj.file ? vj.file.name : $t('upload_your_file')"
                v-model="vj.file"
                @change="onChange($event, j)"
            />
            <small v-if="!vj.annexed" class="text-center text-danger"
            >Tamaño máximo del archivo 8 Mb</small
            >
          </div>

          <div class="col-12 col-md-6" v-if="vj.annexed">
            <button
                type="submit"
                class="btn btn-success"
                @click.prevent="openFileTab(vj.annexed)"
            >
              <app-icon name="file"/>
              Ver
            </button>

            <button
                type="submit"
                class="btn btn-danger"
                @click.prevent="openDeleteModal(j, vj)"
            >
              <app-icon name="trash-2"/>
              Eliminar
            </button>
          </div>

          <div class="col-12 col-md-5" v-if="vj.annexed">
            <app-input
                :id="`filename_${j}`"
                type="text"
                v-model="vj.filename"
                placeholder="Descripcion del archivo"
                @keyup="onKeyUp(j)"
            />
            <small v-if="!vj.filename" class="text-center text-danger"
            >Es necesario agregar una descripción</small
            >
          </div>
          <div class="col-12 col-md-2 text-center" v-if="!vj.annexed">
            <button
                type="submit"
                class="btn btn-warning"
                @click="removeRowFile(j)"
                v-if="!vj.annexed"
            >
              Quitar
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <button type="submit" class="btn btn-primary" @click="addFile()">
              <app-icon name="plus"/>
              Agregar archivo
            </button>
          </div>
        </div>
        <hr/>
        <div class="col-12" v-if="meeting_linkk">
          <app-note
              class="mb-primary"
              :show-title="false"
              :notes="['Ya tiene registrado una convocatoria de comisión de acreditación']"
          />
        </div>

      </div>
    </div>
     <app-confirmation-modal 
      v-if="isAddModalStatePrevious" 
      :modal-id="'StatePrevious'"
      title="Confirmación"
      icon="alert-circle"
      message="¿Está seguro que desea volver al estado anterior?"
      @confirmed="confirmedReturnStatus"
      @cancelled="cancelledPreviousModal"/>
  </div>
 
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
import {axiosPost, axiosDelete} from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],
  props: {
    evalTestId: String,
  },
  data() {
    return {
      isAddEditModalActive: false,
      isAddModalStatePrevious: false,
      previousbutton: 0,
      accAplicationId: null,
      preloader: false,
      inputs: {},
      observation_return: '',
      docs: "",
      observation: "",
      deleteModal: false,
      selected: "",
      evaluations: [],
      additional_600: [],
      list_commi: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      commission: 0,
      list: [],
      members: [],
      fields: {},
      titulo: "",
      personal_remote: 0,
      options: [
        {
          id: "0",
          value: "Presencial",
        },
        {
          id: "1",
          value: "Remota",
        },
      ],
      optionsPreviousState: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      meeting_link: "",
      meeting_time: "",
      meeting_date: new Date(),
      meeting_linkk: null,
      commission_subject: "",
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
          ? this.$store.state.evaluatorReview.evalTest
          : {};
    },
    accApp() {
      return this.evalTest ? this.evalTest.accreditation_applications : null;
    },
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
    members: function () {
      this.chargeDate();
    },
  },

  created() {
    this.dataInfo();
    this.dataList();
    this.loadForm();
    this.optionsData();
  },

  methods: {
    openModalConfirm(){
        if(!this.observation_return.trim()){
          this.$toastr.e('Por favor ingrese una observación.');
          return;
        }
        this.isAddModalStatePrevious = true
    },
    async confirmedReturnStatus() {
      this.preloader = true
      try {
        const formData = new FormData();
        formData.append('observation_return', this.observation_return);

        const url = `/accreditationtechnical/desicionmaking/revert/${this.$store.state.evaluatorReview.evalTestId}`;
        const response = await axios.post(url,formData);

        if (response.status == 200) {
          this.isAddModalStatePrevious = false
          this.$toastr.s("Operación exitosa", "Se ha regresado al estado anterior correctamente");
          setTimeout(() => {
            window.location.href = `/accreditationtechnical/desicionmaking`;
          }, 1500);
        } else {
          this.$toastr.e('Algo salió mal, por favor intente nuevamente.');
        } 
      } catch (error) {
        this.preloader = false
        this.$toastr.e("Ha ocurrido un error, intente de nuevo mas tarde");
      }finally {
        this.preloader = false;
      }
    },
    cancelledPreviousModal(){
      this.isAddModalStatePrevious = false;
    },

    addFile() {
      if (this.additional_600.length >= 15) {
        this.$toastr.e("Solo se pueden adjuntar un maximo de 15 archivos");
        return;
      }
      this.additional_600.push({
        record_id: this.accAplicationId,
        filename: null,
        file: null,
      });
    },

    openFileTab(file) {
      const w = window.open(file.path, "_blank");
      w.focus();
    },

    openDeleteModal(j, vj) {
      this.deleteModal = true;
      this.tmp = {
        j: j,
        vj: vj,
      };
    },

    removeRowFile(j) {
      this.additional_600 = this.additional_600.filter(
          (value, index) => index != j
      );
    },

    cancelled() {
      this.deleteModal = false;
    },

    onChange(e, j) {
      const tmp = this.additional_600[j];
      if (!tmp.file) return;

      if (tmp.file.size > 8700000) {
        this.$set(this.additional_600[j], "file", null);
        this.$set(this.additional_600[j], "filename", null);
        this.$toastr.e("El tamaño maximo permitido por archivo es de 8MB");
        return;
      }
      if (!tmp.filename) this.$set(this.additional_600[j], "filename", "");
      this.chargeFile(j);
    },

    onKeyUp(j) {
      const tmp = this.additional_600[j];
      if (!tmp.annexed) {
      } else {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => this.chargeFile(j), 1000);
      }
    },

    removeRowFile(j) {
      this.additional_600 = this.additional_600.filter(
          (value, index) => index != j
      );
    },

    chargeFile(j) {
      this.deleteLoader = true;
      const url = `${actions.DESICION_MAKING}/addFileAttach`;
      const tmpo = this.additional_600[j];
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.additional_600[j])) {
        formData.append(key, value);
      }
      axiosPost(url, formData)
          .then((res) => {
            this.deleteLoader = false;
            if (tmpo.file) {
              const data = res.data.data[res.data.data.length - 1];
              const tmp = [...this.additional_600];
              tmp[j] = data;
              this.additional_600 = tmp;
            }
          })
          .catch(({error}) => {
          });
    },

    confirm() {
      const url = `${actions.DESICION_MAKING}/destroyFileAttach?eval_annexed_id=${this.tmp.vj.record_id}&id=${this.tmp.vj.id}&type=${this.tmp.vj.type}`;
      axiosDelete(url)
          .then((res) => {
            this.deleteModal = false;
            this.deleteLoader = false;
            const {data} = res.data.data;
            if (this.tmp.vj.type == "additional_600") {
              const tmp = this.additional_600.filter(
                  (value, index) => index != this.tmp.j
              );
              this.additional_600 = tmp;
            }
          })
          .catch(({error}) => {
          });

    },

    dataInfo() {
      let url = `${actions.DESICION_MAKING}/show?evalId=${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.accAplicationId = response.data.id;
        this.inputs = response.data;
        this.docs = response.data;
        this.additional_600 = response.data.additional_600;
        this.meeting_linkk = response.data.meeting_link;
      });
    },
    dataList() {
      let url = `${actions.TECHNICAL_ANALYSIS_REPORT}/decisionDirectorFile/directorTechnicalReport/evaluationList/${this.$store.state.evaluatorReview.evalTestId}`;
      this.axiosGet(url).then((response) => {
        this.evaluations = response.data.evaluations;
      });
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabFor(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },

    submit() {
      // if (this.inputs.file_2){
        this.preloader = true;
        let formData = new FormData();
        for (const [key, value] of Object.entries(this.inputs)) {
          formData.append(key, value);
        }
        formData.append(
            "accreditationId",
            this.$store.state.evaluatorReview.evalTestId
        );
        this.save(formData);
      // }else{
      //   this.$toastr.e(this.$t("Se necesita adjuntar un archivo"));
      // }
    },

    afterSuccess({data: {data}}) {
      this.preloader = false;
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    // openDeleteModal(fileName) {
    //   this.selected = fileName;
    //   this.deleteModal = true;
    // },

    confirmed(fileName) {
      this.inputs[fileName] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {

        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          evidence_member_participation:
          this.$store.state.evaluatorReview.evalTest
              .evidence_member_participation,
          technical_file_analysis_report:
          this.$store.state.evaluatorReview.evalTest
              .technical_file_analysis_report,
          maintenance_plan:
          this.$store.state.evaluatorReview.evalTest.maintenance_plan,
          director_technical_report:
          this.$store.state.evaluatorReview.evalTest.director_technical_report,
          scope605: this.$store.state.evaluatorReview.evalTest.scope605,
        };

        // console.log(this.inputs);
      }
    },
    optionsData() {
      this.axiosGet(
          `${actions.INSTANCE_MEMBERS_REVIEW}/accreditationCommission?evalTestId=${this.evalTestId}`
      ).then((response) => {
        this.list = response.data.accreditationCommission;

        // this.internalCommittee = response.data.internalCommittee;
        // this.technicalReviewer = response.data.technicalReviewer;
      });
    },
    chargeDate() {
      var datos = {};
      datos["id"] = this.evalTestId;
      datos["members"] = this.members;
      var url = `${actions.INSTANCE_MEMBERS_REVIEW}/accreditationCommissionInfo`;
      axios.post(url, datos).then((response) => {
        this.fields = response.data.accreditationCommissionTable;
      });
    },
    submitNotify() {
      if (!this.meeting_date || !this.meeting_time || !this.meeting_link) {
        this.$toastr.e(
            "Es necesario llenar todos los campos obligatorios"
        );

        return;
      }
      if (this.members) {
        var type = "";
        var inputs = [];
        var contador = 0;
        for (let item of this.fields) {
          if (item.selected == true) {
            type = item.type;
            inputs.push(item);
          }

          if (item.coordinator == true) {
            contador = contador + 1;
          }
        }

        if (inputs.length == 0) {
          this.$toastr.e("Debe seleccionar por lo menos un miembro");
        } else {
          if (type == "RT" && inputs.length > 1) {
            this.$toastr.e(
                "Para tipo revisor tecnicó, solo debe seleccionar un técnico ha seleccionado " +
                inputs.length
            );
          } else if (type == "RT" && inputs.length == 1) {
            var input = {};
            input["fields"] = inputs;
            this.preloader = true;
            this.selectedUrln = `${actions.INSTANCE_MEMBERS_REVIEW}/storeNotify/${this.accAplicationId}`;
            axios.patch(this.selectedUrln, input).then((response) => {
              this.afterSuccessNotify(response);
              this.preloader = false;
            });
          } else {
            if (
                (type == "AC" && contador != 1) ||
                (type == "IC" && contador != 1)
            ) {
              this.$toastr.e(
                  "Se debe elegír 1 presidente, elegidos " + contador
              );
            } else {
              var input = {};
              input["fields"] = inputs;
              input["meeting_date"] = this.meeting_date;
              input["meeting_time"] = this.meeting_time;
              input["meeting_link"] = this.meeting_link;
              input["personal_remote"] = this.personal_remote;
              input["accId"] = this.accAplicationId;
              input["commission_subject"] = this.commission_subject;
              this.preloader = true;
              this.selectedUrln = `${actions.INSTANCE_MEMBERS_REVIEW}/storeNotify/${this.accAplicationId}`;
              axios.patch(this.selectedUrln, input).then((response) => {
                this.afterSuccessNotify(response);
                this.preloader = false;
              });
            }
          }
        }
      } else {
        this.$toastr.e("Se debe elegir por lo menos un miembro");
      }
    },
    afterSuccessNotify(res) {
      this.$toastr.s("Notificación enviada para la comosión de acreditación");
    },
  },
};
</script>
